import PropTypes from 'prop-types'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import GoogleMap from 'components/GoogleMap'
import SectionWrapper from 'components/SectionWrapper'
import SliderMobile from 'components/SliderMobile'
import { ResizeContext } from 'contexts/Resize'

import AddressCard from './components/AddressCard'
import ContactsCard from './components/ContactsCard/ContactsCard'
import {
  ContactsCardsWrapper,
  FirstBlockWrapperStyled,
  SecondBlock,
  Slide,
} from './styles'

const languageMapping = {'be': 'fr'}

const Contacts = ({ texts, pathCdn, language, coordinates }) => {
  const languageMapped = languageMapping[language] || language
  const viewport = React.useContext(ResizeContext)

  const [isTranslated, setIsTranslated] = React.useState(false)
  const [persons, setPersons] = React.useState(() =>
    texts.persons.list.filter(
      person => !!person.title && !!person.icon && !!person.email,
    ),
  )

  React.useEffect(() => {
    setPersons(
      texts.persons.list.filter(
        person => !!person.title && !!person.icon && !!person.email,
      ),
    )
  }, [texts.persons.list])

  const personsCards = React.useMemo(
    () =>
      !!persons &&
      persons.map((value, key) =>
        viewport.mobile ? (
          <Slide key={key}>
            <ContactsCard
              key={key}
              title={value.title}
              email={value.email}
              personName={value.name}
              personPhoto={value.photo}
              phoneLink={value.phone.link}
              iconCode={`contacts_${value.icon}`}
              photoPath={pathCdn}
            />
          </Slide>
        ) : (
          <ContactsCard
            key={key}
            withTransform={true}
            isTranslated={isTranslated}
            title={value.title}
            email={value.email}
            personName={value.name}
            personPhoto={value.photo}
            phone={value.phone.value}
            phoneLink={value.phone.link}
            iconCode={`contacts_${value.icon}`}
            photoPath={pathCdn}
          />
        ),
      ),
    [viewport.mobile, persons, pathCdn, isTranslated],
  )

  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.8,
    rootMargin: '60% 0px 0px',
  })

  React.useEffect(() => {
    if (!viewport.mobile && isTranslated !== inView) setIsTranslated(inView)
  }, [inView, isTranslated, viewport.mobile])

  return (
    <>
      <FirstBlockWrapperStyled
        beforeElement={
          <GoogleMap
            viewport={viewport}
            coordinates={coordinates}
            language={languageMapped}
          />
        }
      >
        <AddressCard titles={texts.first} />
      </FirstBlockWrapperStyled>
      <SecondBlock>
        {viewport.mobile ? (
          <SliderMobile>{personsCards}</SliderMobile>
        ) : (
          <SectionWrapper>
            <ContactsCardsWrapper ref={ref}>
              {personsCards}
            </ContactsCardsWrapper>
          </SectionWrapper>
        )}
      </SecondBlock>
    </>
  )
}

Contacts.propTypes = {
  language: PropTypes.string.isRequired,
  texts: PropTypes.shape({
    first: PropTypes.shape({
      call_us: PropTypes.string.isRequired,
      go_to_site: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      write_us: PropTypes.string.isRequired,
    }).isRequired,
    persons: PropTypes.shape({
      list: PropTypes.array.isRequired,
    }),
  }).isRequired,
  pathCdn: PropTypes.string.isRequired,
  coordinates: PropTypes.object,
}

export default Contacts
